import { makeAssessmentService } from "services/assessmentService";

const staffService = makeAssessmentService("staff");

export default staffService;
